import { render, staticRenderFns } from "./PurchasesInvoiceViewDetails.vue?vue&type=template&id=2d2af118"
import script from "./PurchasesInvoiceViewDetails.vue?vue&type=script&lang=js"
export * from "./PurchasesInvoiceViewDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports